module.exports = __webpack_public_path__ + "img/unlock.fc61c974.svg";